import { updateElement } from '@editor2/reducers/editor/editorSlice';
import {
	type SAQuestion,
	type ResponseBoard,
	type SAQuestionValidation
} from '@editor2/types/pageElements';
import { commonPayload, isExactMatchElementValidation } from './elementValidationsService';

export const updateValidation = (
	element: SAQuestion | ResponseBoard,
	validation: SAQuestionValidation,
	validationIndex: number,
	courseId: number
) => {
	const validations = [
		...element.validations.slice(0, validationIndex),
		validation,
		...element.validations.slice(validationIndex + 1)
	];
	return updateElement({ ...commonPayload(element, courseId), validations });
};

export const toggleExactMatchValidationOverride = (element, courseId, defaultRejoinders) => {
	const validations = [...element.validations];
	if (
		!element.exactMatchOverride &&
		!validations.some((val) => isExactMatchElementValidation(val))
	) {
		validations.push({
			name: 'exact-match',
			enabled: false,
			parameters: {},
			rejoinders: defaultRejoinders,
			element_override: true,
			source: 'element'
		});
	}
	return updateElement({
		...commonPayload(element, courseId),
		validations,
		...{ exactMatchOverride: !element.exactMatchOverride }
	});
};
